'use strict';

import * as Redux from 'redux';
import My from '../../checkout/reducers/my';
import BraintreeToken from '../../checkout/reducers/braintreeToken';
import BraintreeClient from '../../checkout/reducers/braintreeClient';
import HostedFields from '../../checkout/reducers/hostedFields';
import LocalFields from '../../checkout/reducers/localFields';

//import CartContents from '../cart/reducers/cart-contents';
import PostTokenCart from '../../checkout/reducers/braintreePostTokenCart';

import PostTokenAndOrganization from '../../checkout/reducers/braintreePostTokenAndOrganization';
import TOS from '../../checkout/reducers/tos.js';
import TOSAgreed from '../../checkout/reducers/tos-agreed.js';
import CreateNewTOSAgreed from '../../checkout/reducers/create-new-tos-agreed.js';
import CreateNew from './reducers/create-new.js';

export default Redux.createStore(
    Redux.combineReducers({
        my: My,
        braintreeToken: BraintreeToken,
        braintreeClient: BraintreeClient,
        //cartContents: CartContents,
        hostedFields: HostedFields,
        localFields: LocalFields,
        postTokenCart: PostTokenCart,
        postTokenAndOrganization: PostTokenAndOrganization,
        tos: TOS,
        tosAgreed: TOSAgreed,
        createNew: CreateNew,
        createNewTosAgreed: CreateNewTOSAgreed
    })
);
